/*
c * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:42 PM
 *
 */

/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/1/22, 3:54 PM
 *
 */

import { Link } from 'react-router-dom';
import { Tab } from '@headlessui/react';
import { WarningOctagon } from 'phosphor-react';
import { useAppSelector } from 'stores';

import { Member, MemberTestList } from 'features/members/types';
import { getSubTestList } from 'features/members/utils/getSubTestList';

import Button from 'components/Button';
import { TableView } from 'components/Table';
import ProfileTestExport from 'features/members/components/others/ProfileTestExport';
import {
  ProfileTestGridView,
  ProfileTestTableRow,
} from 'features/members/components/table/ProfileTestTableRow';

interface IProfileTestTabProps {
  testList: MemberTestList | undefined;
  selectedMember: Member;
}

export const ProfileTestTab = ({ testList, selectedMember }: IProfileTestTabProps) => {
  const subTestList = testList ? getSubTestList(testList.list) : [];
  const user = useAppSelector((state) => state.auth.user);

  const activeClassName = 'py-3 px-10 rounded-sm text-xl bg-gray-800 text-white font-medium';
  const inactiveClassName =
    'py-3 px-10 rounded-sm text-xl text-gray-700 font-medium hover:bg-gray-200';

  return !testList ? (
    <div className="flex  items-center space-x-2 text-xl font-medium text-error-400 ">
      <WarningOctagon size={24} /> <span>No Test Details Found</span>
    </div>
  ) : (
    <Tab.Group>
      <div className="flex items-center justify-between gap-4 sm:flex-col sm:items-start ">
        <Tab.List className="space-x-4 print:hidden">
          <Tab className={({ selected }) => (selected ? activeClassName : inactiveClassName)}>
            <div className="">Table</div>
          </Tab>

          <Tab className={({ selected }) => (selected ? activeClassName : inactiveClassName)}>
            Grid
          </Tab>
        </Tab.List>
        <div className="flex items-start gap-2">
          <ProfileTestExport testList={testList} selectedMember={selectedMember} />{' '}
          {selectedMember.role && selectedMember.role.slug === 'patient' ? (
            user?.id === 1 ? (
              <Link to="/members/org_admin/patient/test_report">
                <Button size="sm">Generate Test Report</Button>
              </Link>
            ) : (
              <Link to="/members/patient/test_report">
                <Button size="sm">Generate Test Report</Button>
              </Link>
            )
          ) : null}
        </div>
      </div>
      <hr className="border-t-[1px] border-gray-200 " />
      {testList && (
        <>
          <Tab.Panels>
            <Tab.Panel>
              <TableView
                loading={!testList}
                data={subTestList}
                tableHeadings={['Test Date', 'Temperature', 'Test Result']}
                search={false}
                tableRowComponent={<ProfileTestTableRow />}
                paginate={true}
                paginateObject={testList.pagination}
              />
            </Tab.Panel>
          </Tab.Panels>
          <Tab.Panel>
            <ProfileTestGridView testDetails={testList} />
          </Tab.Panel>
        </>
      )}
    </Tab.Group>
  );
};
